import Joi from 'joi';

import { generateJoiValidation } from '@/shared/validations/generateJoiValidation';
import { Documents } from '@/modules/documents/documents.model';
import { objectId } from '@/shared/validations/custom.validation';

export const createDocuments = () => ({
  body: generateJoiValidation(Documents.schema),
});

export const updateDocuments = () => ({
  query: Joi.object().keys({
    id: Joi.string().custom(objectId).required(),
  }),
  body: generateJoiValidation(Documents.schema, true),
});

export const getDocuments = {
  query: Joi.object().keys({
    name: Joi.string(),
    sortBy: Joi.string(),
    search: Joi.string(),
    limit: Joi.number().integer().min(1),
    page: Joi.number().integer().min(-1),
    companyId: Joi.string(),
    includeTimeStamps: Joi.boolean(),
    project: Joi.string(),
    status: Joi.string(),
  }),
};

export const getDocumentsById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};

export const deleteDocumentsById = {
  params: Joi.object().keys({
    id: Joi.string().custom(objectId),
  }),
};
